<script setup lang="ts">
import { ref } from "vue";

const showResult = ref(false);


function open() {
  showResult.value = true;
}

defineExpose({
  open,
  close
})

function close() {
  showResult.value = false;
}
</script>
<template>
  <el-dialog v-model="showResult" width="100%" style="max-width: 500px">
    <div class="">
      <h2>玩法介绍</h2>
      <div class="affix">
        <p>1. 构建你的卡组，点击<b class="crtd">对决</b>开始匹配</p>
        <p>2. 对局时间<span class="info">3分钟</span>，前<span class="info">2分钟</span>每<span class="info">2秒</span>获得<span
            class="crt">1金币</span>，拖动卡牌进行部署</p>
        <p>3. 最后<span class="info">1分钟</span>进行双倍金币时间，每<span class="info">1秒</span>获得<span
            class="crt">1金币</span>，进行更激烈的战斗</p>
        <p>4. <span class="info">3分钟</span>内击败玩家或更多随从的一方获得胜利，胜利获得积分、<span class="grow">2点决斗卡包进度</span>和<span
            class="legend">1个随机卡包</span>(若槽位未满)，失败则损失积分、获得<span class="grow">1点决斗卡包进度</span></p>
        <p>5. 若<span class="info">3分钟</span>未结束则会进入<b class="shrink">死亡烈焰阶段</b>，此时玩家和随从每秒损失<span
            class="shrink">3%的生命值</span>，任意玩家和随从死亡即游戏结束
        </p>
        <p>6. <span class="info">3000分</span>之前或段位差距过大会获得积分补偿</p>
        <p>7. 升级卡牌获得经验提升玩家等级</p>
        <p>8. 对局内玩家棋子和随从的等级等同于玩家等级最大不超过13级</p>
        <p>9. 对局内可以切换详细模式/简洁模式查看卡牌详情和战场局势</p>
        <p>10. 当前为<span class="shrink">删档内测版本</span>，后续会推出更多卡牌、道具、等级等相关的功能</p>
      </div>
    </div>
    <template #footer>

    </template>
  </el-dialog>
</template>
<style lang="scss" scoped></style>